import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-veranstaltungs-typen-deaktivieren';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentVeranstaltungsTypenDeaktivierenEffects {

    DokumentVeranstaltungsTypenDeaktivieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_VERANSTALTUNGS_TYPEN_DEAKTIVIEREN),
        mergeMap((x: ac.PostDokumentVeranstaltungsTypenDeaktivierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentVeranstaltungsTypenDeaktivieren(x.dokumentVeranstaltungsTypenRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentVeranstaltungsTypenDeaktivierenErfolgreichAction(result, x.dokumentVeranstaltungsTypenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentVeranstaltungsTypenDeaktivierenFehlerAction(error, x.dokumentVeranstaltungsTypenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentCommandService);
        }
        return this.service;
    }
}
